import type { TrackedTranslation, TranslationTag } from '@ps/web-core-intl';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import type { MouseEvent } from 'react';
import React from 'react';

import ManageCurrenciesIcon from '../../assets/currencies.svg';
import DepositIcon from '../../assets/deposit.svg';
import TransactionHistoryIcon from '../../assets/history.svg';
import DepositLimitsIcon from '../../assets/limits.svg';
import TransfersIcon from '../../assets/transfer.svg';
import WalletIcon from '../../assets/wallet.svg';
import WithdrawIcon from '../../assets/withdraw.svg';

import { container, text, title } from './WalletButton.scss';

interface Props {
  description?: TranslationTag;
  onClick?(e: MouseEvent): void;
  translation: TrackedTranslation;
  variant: 'currencies' | 'deposit' | 'history' | 'limits' | 'transfer' | 'withdraw' | 'methods';
}

const icons = {
  currencies: <ManageCurrenciesIcon />,
  deposit: <DepositIcon />,
  history: <TransactionHistoryIcon />,
  limits: <DepositLimitsIcon />,
  methods: <WalletIcon />,
  transfer: <TransfersIcon />,
  withdraw: <WithdrawIcon />
};

const WalletButton: React.FC<Props> = ({ description, onClick, translation, variant }) => {
  const { buttonPressed } = useTrackers();
  const buttonName = useTrackingLabel(translation);

  const handleClick = (event: React.MouseEvent) => {
    buttonPressed({ buttonName });
    onClick?.(event);
  };

  return (
    <div onClick={handleClick} className={container}>
      {icons[variant]}
      <div className={title}>
        <Translation {...translation} />
      </div>
      {description && (
        <div className={text}>
          <Translation {...description} />
        </div>
      )}
    </div>
  );
};

export default WalletButton;
